import { createContext } from "react";

export const TableRefContext = createContext();
